module.exports = __webpack_public_path__ + "img/fighter.ba581a3a.png";